<div
	[ngClass]="{
		popupFormulario: data.popupFormulario,
		popup: !data.popupFormulario
	}"
	cdkDrag
	cdkDragRootElement=".cdk-overlay-pane"
	cdkDragBoundary=".cdk-overlay-container"
	[cdkDragDisabled]="data.isDragable !== true"
>
	<!-- Header -->
	@if (data.isDragable) {
		<div class="drag-handle" cdkDragHandle>
			<svg width="24px" fill="currentColor" viewBox="0 0 24 24">
				<path
					d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
				></path>
				<path d="M0 0h24v24H0z" fill="none"></path>
			</svg>
		</div>
	}
	<div class="container">
		<div class="popup-header">
			@if (data.title) {
				<h1
					[ngClass]="{ 'color-title': data.popupFormulario }"
					mat-dialog-title
				>
					{{ data.title }}
				</h1>
			}
			@if (isSmall || isXSmall || isMedium) {
				<button mat-icon-button (click)="close()">
					<lucide-icon name="x"></lucide-icon>
				</button>
			}
		</div>
		@if (data.subtitle) {
			<h2 mat-dialog-content>{{ data.subtitle }}</h2>
		}
		<!-- Components -->
		<ng-container #container></ng-container>
	</div>

	<!-- Action buttons -->
	@if (data.popupFormulario) {
		<div class="popup-actions-container">
			@if (data.buttonCancelText !== '') {
				<div>
					<app-button
						(btnClick)="cancel()"
						color="warn"
						[buttonText]="data.buttonCancelText"
					></app-button>
				</div>
			}
			@if (data.buttonConfirmText) {
				<app-button
					[isDisabled]="!(validityFormService.valid | async)"
					(btnClick)="confirm()"
					color="primary"
					[buttonText]="data.buttonConfirmText"
				></app-button>
			}
		</div>
	}
	@if (!data.popupFormulario) {
		<div class="container-labels">
			@if (data.buttonConfirmText) {
				<span
					[style.pointer-events]="
						(validityFormService.valid | async) ? 'auto' : 'none'
					"
					class="label-opciones mat-typography"
					(click)="confirm()"
				>
					<b>{{ data.buttonConfirmText }}</b>
				</span>
			}
			<span class="label-opciones mat-typography" (click)="cancel()">
				<b> {{ data.buttonCancelText }}</b>
			</span>
		</div>
	}
</div>
